import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import RequestResponse from './RequestResponse';
import RequestResponseTabState from './RequestResponseTabState';

export default class RequestResponseTabView extends BufferTabView<RequestResponseTabState> {
  render(): this {
    const props = {
      requestId: this.model.get('requestId'),
    };
    renderToDOM(<RequestResponse {...props} />, this.el);
    return this;
  }

  remove(): Backbone.View<RequestResponseTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

RequestResponseTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
